module.exports = __webpack_public_path__ + "img/mail-opened.834ee758.png";